import { fetchTournamentDetail, fetchTournaments, postTournament } from "../../lib/cloud";
import type { TournamentDetail, TournamentSummary } from "./types";

export async function loadTournamentLists(): Promise<{
  upcoming: TournamentSummary[];
  active: TournamentSummary[];
  ended: TournamentSummary[];
  me: {
    registered: TournamentSummary[];
    dotsEarned: number;
    tournamentsWon: number;
  };
  serverNow: string;
}> {
  const data = await fetchTournaments();
  return {
    upcoming: data.upcoming as TournamentSummary[],
    active: data.active as TournamentSummary[],
    ended: data.ended as TournamentSummary[],
    me: (data as { me?: {
      registered: TournamentSummary[];
      dotsEarned: number;
      tournamentsWon: number;
    } }).me ?? { registered: [], dotsEarned: 0, tournamentsWon: 0 },
    serverNow: data.serverNow,
  };
}

export async function loadTournamentDetail(id: string): Promise<TournamentDetail> {
  const data = await fetchTournamentDetail(id);
  const t = data.tournament as TournamentDetail;
  return t;
}

export function registerTournament(tournamentId: string) {
  return postTournament({ action: "register", tournamentId });
}

export function leaveTournament(tournamentId: string) {
  return postTournament({ action: "leave", tournamentId });
}

export function joinTournamentMatch(matchId: string) {
  return postTournament({ action: "join-match", matchId });
}

export function reportTournamentProgress(matchId: string, score: number) {
  return postTournament({ action: "report-progress", matchId, score });
}

export function finishTournamentRun(matchId: string, score: number) {
  return postTournament({ action: "finish-run", matchId, score });
}

export function pollTournamentMatch(matchId: string) {
  return postTournament({ action: "poll-match", matchId });
}
